import { Link } from 'react-router-dom';
import PlanGallery from '../components/PlanGallery';

const Projects = () => {
  return (
    <>
      {/* Page Title */}
      <div className="page-title-area ptb-100">
        <div className="container">
          <div className="page-title-content">
            <h1>Projects Details</h1>
            <ul>
              <li className="item"><Link to="/">Home</Link></li>
              <li className="item"><Link to="/projects"><i className="flaticon-play-button"></i>Projects Details</Link></li>
            </ul>
          </div>
        </div>
        <div className="bg-image">
          <img src="/assets/img/page-title/projects-details-bg.jpg" alt="Projects Background" />
        </div>
      </div>

      {/* Project Details Section */}
      <div className="projects service-details-area pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="image">
                <img src="/assets/img/projects/b11.png" alt="The Rising" />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="project-info">
                <h3>Project Information</h3>
                <p>It is a long established fact that a reader will be distracted by the readable content of a page.</p>
                <ul className="info-list">
                  <li>
                    <span><i className="flaticon-play-button"></i>Project Name:</span>
                    <span>The Rising</span>
                  </li>
                  <li>
                    <span><i className="flaticon-play-button"></i>Flats:</span>
                    <span>Luxurious 60 Flats</span>
                  </li>
                  <li>
                    <span><i className="flaticon-play-button"></i>Water Storage:</span>
                    <span>120000 liters</span>
                  </li>
                  <li>
                    <span><i className="flaticon-play-button"></i>Lift:</span>
                    <span>2 Lifts of 8 Passenger Capacity</span>
                  </li>
                  <li>
                    <span><i className="flaticon-play-button"></i>Location:</span>
                    <span>Devlali-Chehedi, Nashik Road</span>
                  </li>
                  <li>
                    <span><i className="flaticon-play-button"></i>Secured Entry:</span>
                    <span>Single Entry From Ground Floor</span>
                  </li>
                  <li>
                    <span><i className="flaticon-play-button"></i>EV Charging Point:</span>
                    <span>For Each Flat In Parking Spot</span>
                  </li>
                  <li>
                    <span><i className="flaticon-play-button"></i>Staircase:</span>
                    <span>Two Spacious Staircases</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Finished Projects Section */}
      <section className="finished-projects-section style-two pt-100 pb-70 bg-primary">
        <div className="bg-image">
          <img src="/assets/img/project-bg-1.jpg" alt="Background" />
        </div>
        <div className="container">
          <div className="section-title">
            <h2>Our Current <span>Project</span> "The Rising"</h2>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="finished-projects-slider owl-carousel">
                <div className="slider-item">
                  <div className="image">
                    <img src="/assets/img/projects/01.webp" alt="Project" />
                  </div>
                  <div className="overlay-content">
                    <h3>The Rising</h3>
                  </div>
                </div>
                <div className="slider-item">
                  <div className="image">
                    <img src="/assets/img/projects/02.webp" alt="Project" />
                  </div>
                  <div className="overlay-content">
                    <h3>The Rising</h3>
                  </div>
                </div>
                <div className="slider-item">
                  <div className="image">
                    <img src="/assets/img/projects/03.webp" alt="Project" />
                  </div>
                  <div className="overlay-content">
                    <h3>The Rising</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Plans Section */}
      <section className="team-section team-two pt-100 pb-70">
        <div className="container">
          <div className="row align-items-stretch">
            <div className="col-lg-5 col-md-12">
              <div className="team-content">
                <h2 className="color-secondary">Our Plan and Details</h2>
                <div className="cta-btn">
                  <span className="primary-btn">Click On The Image</span>
                </div>
              </div>
            </div>
            <div className="col-lg-7 col-md-12 d-flex">
              <PlanGallery />
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="newsletter-section newsletter-two bg-primary">
        <div className="container">
          <div className="content-container">
            <div className="row">
              <div className="col-lg-6">
                <div className="newsletter-content ptb-100">
                  <h2>DOWNLOAD OUR BROCHURE</h2>
                  <form className="newsletter-form">
                    <div className="input-group">
                      <input
                        className="form-control"
                        placeholder="Click On Download To Get PDF"
                        type="text"
                        readOnly
                      />
                      <div className="cta-btn">
                        <a className="primary-btn" target="_blank" href="/assets/dp.pdf" rel="noreferrer">
                          Download
                        </a>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Projects;
